<div [formGroup]="form">
    <p [ngSwitch]="control.controlType">
        <mat-form-field *ngSwitchCase="'textbox'" appearance="outline">
            <mat-label>{{control.label}}</mat-label>
            <input matInput [formControlName]="control.key" [id]="control.key" [type]="control.type">
            <mat-error *ngIf="!isValid">
                {{control.label}} is required
            </mat-error>
        </mat-form-field>
        <mat-form-field *ngSwitchCase="'dropdown'" appearance="outline">
            <mat-label>{{control.label}}</mat-label>
            <mat-select [formControlName]="control.key">
                <mat-option *ngFor="let opt of options" [value]="opt.key">{{opt.value}}</mat-option>
            </mat-select>
            <mat-error *ngIf="!isValid">
                {{control.label}} is required
            </mat-error>
        </mat-form-field>
        <mat-form-field *ngSwitchCase="'date'" appearance="outline">
            <mat-label>{{control.label}} </mat-label>
            <input formControlName="{{control.key}}" matInput [matDatepicker]="picker1">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <mat-error *ngIf="!isValid">
                {{control.label}} is required
            </mat-error>
        </mat-form-field>
    </p>
</div>